export default __webpack_public_path__ + "static/media/Hair_17_F_C4.b2b92263.svg";